export default __webpack_public_path__ + "static/media/image.39fbb387.png";